import { UntypedFormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';

export const customerNumberDifferent: ValidatorFn = (group: UntypedFormGroup): ValidationErrors | null => {
  let first; let second;
  if (group.get('firstCustomer').value && group.get('secondCustomer').value) {
    first = group.get('firstCustomer').value;
    second = group.get('secondCustomer').value;
  }

  return first !== second ? null : { customerNumberNotDifferent: true };
};
